
import { Component, Prop, Vue } from 'vue-property-decorator';
import HeaderTitle from '@/components/HeaderTitle.vue';
import ActionButton from '@/components/ActionButton.vue';
import { DashboardModel } from '@/models/dashboard';
import { StoreModel } from '@/models/store';
import TryNewAtlasBanner from '@/components/TryNewAtlasBanner.vue';
import { ATLAS_FEATURE_LINKS, getFeatureVersion, setFeatureVersion } from '@/config/atlasFeatures';

@Component({
  components: {
    HeaderTitle,
    ActionButton,
    TryNewAtlasBanner,
  },
})
export default class LiveDemo extends Vue {
  @Prop({ default: null })
  public app!: any;
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  public get calendlyUrl(): string {
    const storeName = this.store.shopName || '';
    return storeName
      ? `https://calendly.com/assisty/30min?a1=${encodeURIComponent(storeName)}`
      : 'https://calendly.com/assisty/30min';
  }

  public async created() {
    try {
      if (!this.store.config.homepageDashboardId) {
        const dashboardModel: DashboardModel = new DashboardModel();
        dashboardModel.id = 117;
        await dashboardModel.copy();
        this.store.config.homepageDashboardId = dashboardModel.id;
        this.store.config.homepageDashboardType = 'PRIVATE';
        this.store.saveSettings();
      }
    } catch (e: any) {
      //
    }
  }
  // AS-10388: opt-in path onto the atlas /book-demo page.
  public get showTryNewDemoBanner(): boolean {
    return getFeatureVersion('liveDemo') === 'classic';
  }

  public switchDemoToAtlas(): void {
    setFeatureVersion('liveDemo', 'atlas');
    this.$router.push(ATLAS_FEATURE_LINKS.liveDemo['/live-demo']);
  }

  public mounted() {
      const calendly = document.createElement('script');
      calendly.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
      document.head.appendChild(calendly);
    }
}
